import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import styles from "./Loading.module.css";
import MAnimada from "../../assets/images/M-animada.gif";
/**
 * Animacion cuando carga algun proceso
 */
const Loading = (props) => {
  const showLoading = props.show;
  const msg = props.msg;
  return (
    <Dialog open={showLoading}>
      <Box className={styles.container__Loading}>
        <div className="w-2/3 h-2/3 mx-auto">
          <img src={MAnimada} alt="Manimada" />
        </div>
        <div className="p-2">{msg ? <p className="font-telefonica">{msg}</p> : <></>}</div>
      </Box>
    </Dialog>
  );
};

Loading.propTypes = {
  show: PropTypes.bool.isRequired,
};

export default Loading;
